'use strict';

const MODEL_HUMANIZED = {
  Aplicacao: 'Aplicação',
  AplicacaoItem: 'Aplicação',
  Gleba: 'Talhão',
  Plantio: 'Plantio',
  PrestacaoServico: 'Serviço de Máquina',
  RegistroChuva: 'Registro de Chuva',
  TransferenciaEstoque: 'Transferência de Estoque',
  TransferenciaEstoqueItem: 'Transferência de Estoque',
  MovimentoEstoqueTransferencia: 'Tratamento de Semente',
  MovimentoEstoqueTransferenciaItem: 'Tratamento de Semente',
  Usuario: 'Usuário'
};

const DEFAULT_MODEL_LABEL = 'Sincronização AgroGestão';
const PER_PAGE = 20;
const NO_PROPRIEDADE = -1;

function humanizeModel(model) {
  if (!model || !model.trim()) {
    return DEFAULT_MODEL_LABEL;
  }
  return MODEL_HUMANIZED[model.trim()] || model.trim();
}

function mapStatus(status) {
  switch ((status || '').toLowerCase()) {
  case 'erro': return 'erro';
  case 'processando':
  case 'enviado': return 'processando';
  case 'pendente': return 'pendente';
  case 'confirmado': return 'confirmado';
  default: return 'erro';
  }
}

function trimOrNull(val) {
  return (val || '').trim() || null;
}

function toCdPropriedade(val) {
  return val !== null && typeof val !== 'undefined' ? String(val) : null;
}

function toNullable(val) {
  return val !== null && typeof val !== 'undefined' ? val : null;
}

function mapItem(raw) {
  return {
    id: raw.id,
    propriedade: (raw.propriedade_descricao || '').trim() || 'Sem propriedade',
    cdPropriedade: toCdPropriedade(raw.cd_propriedade),
    operacaoDescricao: trimOrNull(raw.operacao_descricao),
    dataRegistro: trimOrNull(raw.data_registro),
    talhaoDescricao: trimOrNull(raw.talhao_descricao),
    atividadeDescricao: trimOrNull(raw.atividade_descricao),
    cultivarDescricao: trimOrNull(raw.cultivar_descricao),
    depositoOrigem: trimOrNull(raw.deposito_origem),
    depositoDestino: trimOrNull(raw.deposito_destino),
    pluviometroDescricao: trimOrNull(raw.pluviometro_descricao),
    maquinaDescricao: trimOrNull(raw.maquina_descricao),
    quantidadeChuva: trimOrNull(raw.quantidade_chuva),
    entidade: humanizeModel(raw.model),
    model: trimOrNull(raw.model),
    idLocal: trimOrNull(raw.id_local),
    origem: trimOrNull(raw.origem),
    dataOperacao: raw.data_operacao || raw.created_at || null,
    status: mapStatus(raw.status),
    mensagemErro: raw.mensagem_erro || null,
    codigoErro: toNullable(raw.codigo_erro),
    retryCount: typeof raw.retry_count === 'number' ? raw.retry_count : 0
  };
}

function wrapResponse(rawData) {
  try {
    return { _raw: angular.fromJson(rawData) };
  } catch (e) {
    return { _raw: null };
  }
}

function parseListResponse(response) {
  const data = (response.data || {})._raw || {};
  const summary = data.summary || { total: 0, by_status: {} };
  return {
    summary,
    pagination: data.pagination || null,
    data: (data.data || []).map(mapItem)
  };
}

SyncAgrogestaoServiceFactory.$inject = ['$http'];

function SyncAgrogestaoServiceFactory($http) {
  function list(params) {
    const requestParams = { page: 1, per_page: PER_PAGE, propriedade: NO_PROPRIEDADE, ...params || {} };
    return $http.get(`${SERVER}v2/sync_agrogestao`, {
      params: requestParams,
      transformResponse: [wrapResponse]
    }).then(parseListResponse);
  }

  function reprocessar(id) {
    return $http.patch(`${SERVER}v1/schema_versions/${id}/reprocessar`, {});
  }

  return { list, reprocessar, mapItem };
}

angular.module('webAgro1App').factory('SyncAgrogestaoService', SyncAgrogestaoServiceFactory);
